import React from "react";
import { api } from "@/lib/api";
import { Trash2 } from "lucide-react";

export default function AdminMessages() {
  const [items, setItems] = React.useState([]);
  const load = () => api.get("/contact").then((r) => setItems(r.data));
  React.useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    await api.delete(`/contact/${id}`); load();
  };

  return (
    <div>
      <div className="overline text-[color:var(--sky-cyan)]">Inbox</div>
      <h1 className="mt-3 font-display font-black text-white text-3xl">Contact messages</h1>
      <p className="mt-2 text-[color:var(--sky-admin-muted)]">Messages submitted through your contact form.</p>

      <div className="mt-8 grid gap-3">
        {items.map((m) => (
          <div key={m.id} className="admin-card p-5">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <div className="font-display font-bold text-white text-lg">{m.name} <span className="text-[color:var(--sky-admin-muted)] text-sm font-normal">· {m.email}</span></div>
                <div className="text-xs text-[color:var(--sky-admin-muted)] mt-0.5">{new Date(m.created_at).toLocaleString()} · {m.phone || "—"} · {m.company || "—"}</div>
                {m.subject && <div className="mt-3 text-sm text-white font-semibold">Subject: {m.subject}</div>}
                <p className="mt-2 text-sm text-white/80 whitespace-pre-wrap">{m.message}</p>
              </div>
              <button onClick={() => remove(m.id)} className="admin-btn-ghost text-xs text-red-300 hover:text-red-200"><Trash2 size={13} /></button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="admin-card p-8 text-center text-[color:var(--sky-admin-muted)]">No messages yet.</div>}
      </div>
    </div>
  );
}
